module.exports = __webpack_public_path__ + "static/media/mozambique.eaaac207.png";